// extracted by mini-css-extract-plugin
export var centered = "Page-module--centered--9eb29";
export var full = "Page-module--full--a006f";
export var hideOnMobile = "Page-module--hideOnMobile--976fb";
export var noSpacing = "Page-module--noSpacing--377f7";
export var page = "Page-module--page--e49d9";
export var pageContent = "Page-module--pageContent--25b6d";
export var subTitle = "Page-module--subTitle--0c903";
export var withSpacingBottom = "Page-module--withSpacingBottom--60953";
export var withSpacingTopOnMobile = "Page-module--withSpacingTopOnMobile--55c96";